module.exports = __webpack_public_path__ + "static/media/teaCup.eacca7e0.png";